import React from 'react';

import { useNavigationStore } from '@app/store/zustand';

import { Icon } from '../Icon';
import { Chevron } from '../Toggle/styles';

import { Copyright, SidebarToggle, Wrapper, YatHand } from './styles';

export const SidebarFooter = () => {
    const isMinimized = useNavigationStore((state) => state.isMinimized);
    const setIsMinimized = useNavigationStore((state) => state.setIsMinimized);

    return (
        <Wrapper>
            {!isMinimized && (
                <>
                    <YatHand to="/home">
                        <Icon name="logo" />
                    </YatHand>
                    <Copyright>Copyright © {new Date().getFullYear()}. All Rights Reserved</Copyright>
                </>
            )}

            <SidebarToggle $isMinimized={isMinimized}>
                <Chevron $direction={isMinimized ? 'right' : 'left'} onClick={() => setIsMinimized(!isMinimized)} />
            </SidebarToggle>
        </Wrapper>
    );
};
